module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1162.4c606473.png";